export default __webpack_public_path__ + "static/media/grid.930d9641.less";